export default "__VITE_ASSET__Da9bn3up__"